const ITEMS = [
  "CDRIVE™ BRUSHLESS",
  "38 dB — ABSOLUTE SILENCE",
  "WSAFE™ OUTDOOR",
  "EUROPEAN RAIL MANUFACTURING",
  "OEM / ODM PLATFORM",
  "AIMEASURE™ — COMING SOON",
  "MODULAR RAIL™ — COMING SOON",
  "DESIGNED FOR EUROPE",
];

export default function Marquee({ dark = false }) {
  return (
    <div
      className={`overflow-hidden border-y py-4 select-none ${
        dark ? "bg-obsidian border-white/10 text-slate-500" : "bg-white border-slate-200 text-slate-400"
      }`}
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="flex whitespace-nowrap animate-marquee will-change-transform w-max">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center">
            {ITEMS.map((item, i) => (
              <span
                key={i}
                className="flex items-center font-mono text-[11px] tracking-[0.3em] uppercase"
              >
                <span className="px-8">{item}</span>
                <span className={`w-1 h-1 rotate-45 ${dark ? "bg-signal" : "bg-signal"}`} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
